import { BaseService } from "./../base";
export class NationalityService extends BaseService {
  static get entity() {
    return "nationality";
  }
  static get name() {
    return "nationality";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }

  static async create(data = {}) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}nationalities`, this.name, data);
  }

  static async update(id, data = {}) {
    console.log(id);
    return this.submit("put", `${this.getApiUrlEntity(this.profile)}nationalities/${id}`, this.name, data);
  }
}
